import React, { useMemo } from 'react';
import { Table } from './Table';
import ApplicationsTableMultiColumnFilter from '€components/ApplicationsTableMultiColumnFilter';
import { BrokerApplication } from '€lib/types/Application';

interface ApplicationsTableProps {
    applications: BrokerApplication[];
}

export default function ApplicationsTable({ applications }: ApplicationsTableProps) {
    const columns = useMemo(
        () => [
            {
                Header: 'Case Ref',
                accessor: 'applicationId',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Client Name',
                accessor: 'applicantLastName',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Created Date',
                accessor: 'createdAt',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Current Stage',
                accessor: 'salesPipelineStage',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: "Amount's",
                accessor: 'actualLoanAmount',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Application Type',
                accessor: 'applicationTypeNameInternal',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Product Type',
                accessor: 'loanTypeName',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Product Provider',
                accessor: 'lenderName',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Campaign',
                accessor: 'campaignName',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Click Ref',
                accessor: 'clickRef',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Paid Out Date',
                accessor: 'commissionReceivedDate',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Commission For Partner',
                accessor: 'introducerFee',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
            {
                Header: 'Turned Down Reason',
                accessor: 'turnedDownReason',
                Filter: ApplicationsTableMultiColumnFilter,
                filter: 'multiSelect',
            },
        ],
        [],
    );

    const data = React.useMemo(() => applications, [applications]);

    return <Table columns={columns} data={data} />;
}
